import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
export var GET_APOLLO_STATE = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  {\n    uiData @client {\n      errorMessage\n      showOnlyPM\n      newUserNoMop\n      cardActionMode\n      isLoaded\n      isCTALoading\n      isCTADisabled\n      showInitializeError\n    }\n    reviewData @client {\n      currentStep\n    }\n    orderData @client {\n      token\n      cartId\n      yiftee\n    }\n  }\n"])));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/lib/Graphql/getApolloState.js
// module id = 650
// module chunks = 11